import { Transport } from "esptool-js";

import { SlipDecoder } from "./slip.ts";

/** esptool-js's Web Serial transport with `SlipDecoder` in place of its packet reader. */
export class SlipTransport extends Transport {
    /** esptool-js traces some events to the console even with tracing off; the CLI's output is stdout. */
    override trace(message: string): void {
        if (this.tracing) super.trace(message);
    }

    override async read(timeout: number): Promise<Uint8Array> {
        // The received bytes are private to Transport; its read loop appends to them.
        const self = this as unknown as { buffer: Uint8Array };
        const decoder = new SlipDecoder();
        for (;;) {
            const start = Date.now();
            while (self.buffer.length === 0) {
                if (Date.now() - start >= timeout) {
                    throw new Error(
                        decoder.started
                            ? "No serial data received."
                            : "Serial data stream stopped: Possible serial noise or corruption.",
                    );
                }
                await new Promise((resolve) => setTimeout(resolve, 1));
            }
            const bytes = self.buffer;
            self.buffer = new Uint8Array(0);
            const done = decoder.push(bytes);
            if (done !== undefined) {
                self.buffer = done.rest.slice();
                return done.packet;
            }
        }
    }
}
